import React, { useState } from "react";
import { Typography, Chip, Box, useTheme } from "@mui/material";
import "./index.css";
import TextInput from "../../../components/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { setOnboarding } from "../../../rtkSlices/onboardingSlice";

const initialGoals = {
  productivityAndWork: [
    { id: 1, name: "Notes & To-Do Organization", selected: false },
    { id: 2, name: "Email & Proposal Writing", selected: false },
    { id: 3, name: "Data Analysis & Reporting", selected: false },
    { id: 4, name: "Brainstorming & Ideation", selected: false },
  ],
  careerAndEducation: [
    { id: 1, name: "Resume / Cover Letter Writing", selected: false },
    { id: 2, name: "Study & Research Assistance", selected: false },
    { id: 3, name: "Career & Interview Prep", selected: false },
    {
      id: 4,
      name: "Applications & Forms (Job apps, school forms, etc.)",
      selected: false,
    },
  ],
  personalWellBeing: [
    { id: 1, name: "Emotional Support & Journaling", selected: false },
    { id: 2, name: "Mindfulness & Mental Health Support", selected: false },
    { id: 3, name: "Fitness & Habit Coaching", selected: false },
    { id: 4, name: "Budgeting & Personal Finance", selected: false },
  ],
  creativeAndExpressive: [
    {
      id: 1,
      name: "Creative Writing (stories, scripts, poetry)",
      selected: false,
    },
    { id: 2, name: "Marketing & Content Creation", selected: false },
    { id: 3, name: "Event Planning & Invitations", selected: false },
    { id: 4, name: "Persuasive / Sales Outreach", selected: false },
  ],
  skillsAndHobbies: [
    { id: 1, name: "Language Learning & Translation", selected: false },
    { id: 2, name: "Coding Help & Debugging", selected: false },
    { id: 3, name: "Travel Planning & Itineraries", selected: false },
    { id: 4, name: "Meal Planning & Recipes", selected: false },
    { id: 5, name: "Home Organization & Decluttering", selected: false },
  ],
};

const initialInterests = {
  professionalInterests: [
    { id: 1, name: "Technology & AI", selected: false },
    { id: 2, name: "Business & Marketing", selected: false },
    { id: 3, name: "Finance & Economics", selected: false },
    { id: 4, name: "Education & e-Learning", selected: false },
  ],
  creativeAndCultural: [
    { id: 1, name: "Creative Arts & Design", selected: false },
    { id: 2, name: "Entertainment & Media", selected: false },
    { id: 3, name: "Gaming & Esports", selected: false },
    { id: 4, name: "Fashion & Lifestyle", selected: false },
  ],
  healthAndLifestyle: [
    { id: 1, name: "Health & Wellness", selected: false },
    { id: 2, name: "Sports & Fitness", selected: false },
    { id: 3, name: "Food & Nutrition", selected: false },
    { id: 4, name: "Parenting & Family", selected: false },
    { id: 5, name: "Relationships & Communication", selected: false },
  ],
  scienceAndLearning: [
    {
      id: 1,
      name: "Science & Research (Biology, Chemistry, Physics)",
      selected: false,
    },
    { id: 2, name: "Sustainability & Green Tech", selected: false },
    { id: 3, name: "Politics & Policy", selected: false },
    { id: 4, name: "News & Current Events", selected: false },
    { id: 5, name: "Personal Development & Productivity", selected: false },
  ],
};

const GoalsAndInterests = (props: { interests: boolean }) => {
  const dispatch = useDispatch();
  const onboarding = useSelector((state: any) => state.onboarding.onboarding);
  const fetchedGoals = onboarding && onboarding.goals;
  const fetchedInterests = onboarding && onboarding.interests;
    const theme = useTheme()
  const selectInitialGoals = () => {
    const tempGoals: any = { ...initialGoals };
    Object.keys(fetchedGoals).forEach((goal: any) => {
      if (fetchedGoals[goal].length) {
        fetchedGoals[goal].forEach((g: any) => {
          if (tempGoals[goal].find((tempgoal: any) => tempgoal.name == g)) {
            tempGoals[goal].find(
              (tempgoal: any) => tempgoal.name == g
            ).selected = true;
          }
        });
      }
    });
    return tempGoals;
  };
  const selectInitialInterests = () => {
    const tempInterests: any = { ...initialInterests };
    Object.keys(fetchedInterests)
      .filter((k) => k != "other")
      .forEach((interest: any) => {
        if (fetchedInterests[interest].length) {
          fetchedInterests[interest].forEach((g: any) => {
            if (
              tempInterests[interest].find(
                (tempinterest: any) => tempinterest.name == g
              )
            ) {
              tempInterests[interest].find(
                (tempinterest: any) => tempinterest.name == g
              ).selected = true;
            }
          });
        }
      });
    return tempInterests;
  };
  const [goals, setGoals] = useState<typeof initialGoals>(selectInitialGoals);
  const [interests, setInterests] = useState<typeof initialInterests>(
    selectInitialInterests
  );

const MAX_OTHER_INTEREST_LEN = 160;

const [otherInterestText, setOtherInterestText] = useState(
  fetchedInterests.other || ""
);

  function camelToPascalWithSpaces(input: string): string {
    const spaced = input.replace(/([a-z])([A-Z])/g, "$1 $2");

    const pascal = spaced.replace(/\b\w/g, (char) => char.toUpperCase());

    return pascal;
  }

  const selectGoal = (index: number, type: string) => {
    let tempGoals: any = { ...goals };
    const selectedGoal = tempGoals[type][index];
    tempGoals[type][index].selected = !selectedGoal.selected;
    setGoals(tempGoals);
    const tempOnboarding = JSON.parse(JSON.stringify(onboarding));
    dispatch(
      setOnboarding({
        goals: {
          ...tempOnboarding.goals,
          [type]: tempGoals[type]
            .filter((work: any) => work.selected)
            .map((work: any) => work.name),
        },
      })
    );
  };
  const selectInterest = (index: number, type: string) => {
    let tempInterests: any = { ...interests };
    const selectedGoal = tempInterests[type][index];
    tempInterests[type][index].selected = !selectedGoal.selected;
    setInterests(tempInterests);
    const tempOnboarding = JSON.parse(JSON.stringify(onboarding));
    dispatch(
      setOnboarding({
        interests: {
          ...tempOnboarding.interests,
          [type]: tempInterests[type]
            .filter((work: any) => work.selected)
            .map((work: any) => work.name),
        },
      })
    );
  };

  const handleOtherInterest = (e: React.ChangeEvent<HTMLInputElement>) => {
  const newText = e.target.value;
    setOtherInterestText(newText);            // live counter

  const tempOnboarding = JSON.parse(JSON.stringify(onboarding));
    tempOnboarding.interests.other = newText;
    dispatch(setOnboarding(tempOnboarding));
};

  return (
    <Box className="goals-section">
      <Typography component="div" fontSize={"53px"} fontFamily={"Fredoka"} fontWeight={"600"}>
        Your Goals & Interests
      </Typography>
      <Typography component="div"
        fontSize={"16px"}
        fontFamily={"Poppins"}
        fontWeight={"300"}
        marginTop={"5px"}
        textAlign={"center"}
      >
        {props.interests
          ? `Which of these topics interest you`
          : `I'm eager to learn about your aspirations and hobbies. What are your
        professional or academic pursuits? Also, how would you characterize your
        interests and passions?`}
      </Typography>
      <br />
      {!props.interests ? (
        <>
          <Typography component="div"
            fontSize={"20px"}
            fontFamily={"Poppins"}
            fontWeight={"600"}
          >
            How do you plan to use HiiBo?
          </Typography>
          <Typography component="div"
            fontSize={"16px"}
            fontFamily={"Poppins"}
            fontWeight={"300"}
          >
            {`( at least one is required )`}
          </Typography>
        </>
      ) : null}

      {!props.interests ? <br /> : null}
      {!props.interests
        ? (Object.keys(goals) as (keyof typeof initialGoals)[]).map((goal) => {
            return (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "column",
                }}
              >
                <Typography component="div"
                  fontSize={"18px"}
                  fontFamily={"Poppins"}
                  fontWeight={"600"}
                >
                  {camelToPascalWithSpaces(goal)}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    borderRadius: 2,
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  {goals[goal].map((selection: any, index) => {
                    return (
                      <Chip
                        label={selection.name}
                        variant="outlined"
                        onClick={() => selectGoal(index, goal)}
                        sx={{
                          margin: "7px",
                          marginLeft: "0px",
                          borderColor: "rgba(42, 148, 95, 1)",
                        }}
                        className={selection.selected ? "selected-option" : ""}
                      />
                    );
                  })}
                </Box>
                <br />
              </Box>
            );
          })
        : (Object.keys(interests) as (keyof typeof initialInterests)[]).map(
            (interest) => {
              return (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: "column",
                  }}
                >
                  <Typography component="div"
                    fontSize={"18px"}
                    fontFamily={"Poppins"}
                    fontWeight={"600"}
                  >
                    {camelToPascalWithSpaces(interest)}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      borderRadius: 2,
                      alignItems: "flex-start",
                      width: "100%",
                    }}
                  >
                    {interests[interest].map((selection: any, index) => {
                      return (
                        <Chip
                          label={selection.name}
                          variant="outlined"
                          onClick={() => selectInterest(index, interest)}
                          sx={{
                            margin: "7px",
                            marginLeft: "0px",
                            borderColor: "rgba(42, 148, 95, 1)",
                          }}
                          className={
                            selection.selected ? "selected-option" : ""
                          }
                        />
                      );
                    })}
                  </Box>
                  <br />
                </Box>
              );
            }
          )}
      {props.interests ? (
        <Box sx={{ width: "100%" }}>
          <TextInput
            label={"Additional goals & interests"}
            width="360px"
            maxLength={MAX_OTHER_INTEREST_LEN}
            helperText={`${otherInterestText.length}/${MAX_OTHER_INTEREST_LEN}`}
            handleChange={handleOtherInterest}
            defaultValue={fetchedInterests.other}
            color={theme.palette.primary.main}
          />
        </Box>
      ) : null}
      <br />
    </Box>
  );
};

export default GoalsAndInterests;
